import M from 'backbone.marionette'
import T from './create.html'
import Backbone from 'backbone';
import { FormElement } from '../../utils/bootstrap/formelement';
import { FormHandler } from '../../utils/bootstrap/form/formhandler';
import { Toast } from '../../utils/bootstrap/toast';
import { PunchListitem } from './punchListItem';
import Radio from 'backbone.radio';
import { minutesToTimeString, timeStringToMinutes } from '../../utils/utils';
import { showAlert } from '../../utils/bootstrap/modal';

const PunchList = M.CollectionView.extend({
    tagName: 'ul',
    className: 'list-group',
    childView: PunchListitem,
    viewComparator: function(view){
        return view.model.get('punchDate')
    },
});

export const CreatePunch = M.View.extend({
    template: _.template(T),
    punches: null,
    user: null,
    punchTypes: null,
    relatedModel: null,
    relatedId: null,
    relatedModelModel: null,
    serializeData: function(){
        return _.extend(this.model.toJSON(), {total: minutesToTimeString(this.punches.reduce(function(acc, curr){ 
            return acc + curr.get('punchTimeInMinutes');
        }, 0))})
    },
    initialize: function(){
        var initialData = this.$el.text();
        this.$el.text('');
        const data = JSON.parse(atob(initialData));
        console.log('initialData', data)
        this.relatedModel = data.relatedModel;
        this.relatedId = data.relatedId;
        this.punches = new (Backbone.Collection.extend({idAttribute: 'id'}))(data.punches);
        this.relatedModelModel = new Backbone.Model(data.model);
        this.user = new Backbone.Model(data.user);
        this.punchTypes = new Backbone.Collection(data.punchTypes.map(p => {
            return {id: p, label: p, value: p}
        }));
        this.model = new Backbone.Model();
        this.initModel();

        Radio.channel('punch').on('validate', this.onPunchValidate, this);
    },
    onBeforeDestroy: function() {
        Radio.channel('punch').off('validate', this.onPunchValidate, this);
    },
    initModel: function(){

        console.log('initModel', this.model.toJSON());
        let enseignant_id = null;
        if(this.user.get('Type') == 'enseignant'){
            enseignant_id = this.user.get('id')
        }else if(this.relatedModel == 'competenceetudiant'){
            enseignant_id = this.relatedModelModel.get('enseignant_id');
        }
        this.model.set({
            punchType: this.model.get('punchType') ?? this.punchTypes.at(0).get('id'),
            relatedModel: this.relatedModel,
            relatedId: this.relatedId,
            enseignant_id: enseignant_id,
            punchDate: (new Date()).toISOString().split('T')[0],
            punchTime: (new Date()).toTimeString().split(' ')[0].substring(0,2) + ':00',
            punchTimeString: '00:00',
            teacherComments: '',
        });
    },
    ui: {
        btSubmit: '.btSubmit', 
        btAnnuler: '.btAnnuler',
        enseigantFormGroup: '.enseigantFormGroup',
        nopunch:'.nopunch'
    },
    regions: {
        'punchList': {
            el: '.punchList',
            replaceElement: false,
        },
        'punchType': {
            el: '#punchType',
            replaceElement: true,
        },
        'punchDate': {
            el: '#punchDate',
            replaceElement: true,
        },
        'punchTimeInMinutes': {
            el: '#punchTimeInMinutes',
            replaceElement: true,
        },
        'teacherComments': {
            el: '#teacherComments',
            replaceElement: true,
        },
        'enseignant': {
            el: '#enseignant',
            replaceElement: true,
        }
    },
    events: {
        'click #plus15': 'onPlus15',
        'click #plush': 'onPlusH',
        'click .btSubmit': 'onSubmit',
        'click .btAnnuler': 'onCancel',
    },
    onRender: function(){
        this.showChildView('punchType', new FormElement({
            horizontal: false,
            type: 'select',
            model: this.model,
            attribute: 'punchType',
            collection: this.punchTypes
        }));
        this.showChildView('punchDate', new FormElement({
            horizontal: false,
            type: 'date',
            model: this.model,
            attribute: 'punchDate',
        }));
        this.showChildView('punchTimeInMinutes', new FormElement({
            horizontal: false,
            type: 'time',
            model: this.model,
            attribute: 'punchTimeString',
        }));
        this.showChildView('teacherComments', new FormElement({
            horizontal: false,
            type: 'textarea',
            model: this.model,
            attribute: 'teacherComments',
        }));
        const punchListView = new PunchList({
            childViewOptions: {
                showName: this.user.get('admin'),
                user: this.user
            },
            collection: this.punches,
        });
        this.showChildView('punchList', punchListView);
        this.listenTo(punchListView, 'validate:punch:parent', this.onValidatePunchParent)
        if(this.user.get('admin')){
            this.showChildView('enseignant', new FormElement({
                type: 'indexeurautocomplete',
                model: this.model,
                attribute: 'enseignant_id',
                indexType : 'enseignant',
                hideLabel: true,
                serviceUrl: 'autocomplete/search/enseignant',
                inputAttributes : {
                    placeholder: 'Rechercher un spécialiste...'
                }
            }))
        }else{
            this.ui.enseigantFormGroup.hide();
        }
        if(this.punches.length){
            this.ui.nopunch.hide();
        }else{
            this.ui.nopunch.show();
        }
    },
    onPlus15: function(){
        // get current time value
        var timeStr = this.model.get('punchTimeString');
        if(!timeStr)timeStr = '00:00';
        var parts = timeStr.split(':');
        var date = new Date();
        date.setHours(parseInt(parts[0]));
        date.setMinutes(parseInt(parts[1]));
        // add 15 minutes
        date.setMinutes(date.getMinutes() + 15);
        // set back
        var h = date.getHours();
        if(h<10)h='0'+h;
        var m = date.getMinutes();
        if(m<10)m='0'+m;
        this.model.set('punchTimeString', h+':'+m);    
    },
    onPlusH: function(){
        // get current time value
        var timeStr = this.model.get('punchTimeString');
        if(!timeStr)timeStr = '00:00';
        var parts = timeStr.split(':');
        var date = new Date();
        date.setHours(parseInt(parts[0]));
        date.setMinutes(parseInt(parts[1]));
        // add 1 hour
        date.setHours(date.getHours() + 1);
        // set back
        var h = date.getHours();
        if(h<10)h='0'+h;
        var m = date.getMinutes();
        if(m<10)m='0'+m;
        this.model.set('punchTimeString', h+':'+m);
    },
    onSubmit: function(){
        const formHandler = new FormHandler();
        this.model.set('punchTimeInMinutes', timeStringToMinutes(this.model.get('punchTimeString')));
        formHandler.addModel('punches', this.model);

        this.ui.btAnnuler.prop('disabled', true);
        this.ui.btSubmit.prop('disabled', true);
        formHandler.save('api/specialiste/ajouterpunch/',
            this.onPuchAdded.bind(this),
            this.onPunchAdderror.bind(this)
        )
    },
    onPuchAdded: function(response){
        this.triggerMethod('data:received', response)
        Toast.add('La sauvegarde a fonctionné !', 'success');
        this.ui.btAnnuler.prop('disabled', false);
        this.ui.btSubmit.prop('disabled', false);
        this.punches.add(response);
        
        this.initModel();
        
        this.render();
        this.triggerMethod('close', this);
    },
    onPunchAdderror:function(errors){
        console.log('errors', errors)
        
        this.ui.btAnnuler.prop('disabled', false);
        this.ui.btSubmit.prop('disabled', false);
        if (errors) {
            Toast.add(errors, 'danger');
        }else{
            Toast.add('Une erreur a eu lieu :(', 'danger')
        }
    },
    onCancel: function(){
        this.triggerMethod('close', this);
    },
    onPunchValidate: function(model) {
        // This will be called when PunchListitem triggers the event
        console.log('Validated punch from child:', model, this);

        const formHandler = new FormHandler();
        formHandler.addModel('punches', model);
        formHandler.save('api/specialiste/validerpunch/',
            this.onPunchValidated.bind(this),
            this.onPunchValidateError.bind(this)
        )
        // Do your processing here
    },
    onPunchValidated: function(response){
        console.log('response', response)
        console.log('this.punches', this.punches.toJSON());
        this.punches.add(response, {merge: true});
        console.log('this.punches', this.punches.toJSON());
    },
    onPunchValidateError: function(errors){
        Toast.add('Une erreur a eu lieu :(', 'danger')
    }

})
